import { request } from './client';

/**
 * Forgotten-password, from the outside.
 *
 * Nothing here takes a session, and nothing here can. Somebody who has forgotten their
 * password has by definition failed to log in, which is why these sit on the public
 * /api/password prefix rather than under the profile endpoints - changing a password
 * you know is a different act from recovering one you do not.
 */

/**
 * Ask for a reset link.
 *
 * <strong>Always resolves, whether the address exists or not.</strong> The server
 * deliberately answers the same either way, because a different answer for a known
 * address turns this into a way of asking whether somebody has an account here. The
 * screen has to say the same thing in both cases or it hands back what the server
 * withheld.
 */
export function requestReset(email) {
  return request('/api/password/reset-request', { method: 'POST', body: { email } });
}

/** Whether a token from a link is real and still live, before showing the form. */
export function validateToken(token) {
  return request(`/api/password/validate-token?token=${encodeURIComponent(token)}`);
}

/** Spend the token on a new password. Works once. */
export function resetPassword({ token, newPassword }) {
  return request('/api/password/reset', { method: 'POST', body: { token, newPassword } });
}
